import styled from 'styled-components';

const RateWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  background: #fff;
  padding: 30px;
  gap: 30px;
`;

const RateSubRates = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  width: 100%;
`;

export { RateWrapper, RateSubRates };
